<!--
/*******************************************************************************
*@ 컴포넌트명   : CorporationInfo1.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 수정 [기업]
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="corporation">
    <div class="scroll">
      <contents-header :bg-type="true" title="MCOP-01-01-03-01" />
      <article class="contents">
        <template v-if="siteCode === $config.SITECODE_OGAUC || siteCode === $config.SITECODE_OGIND">
          <!--
            MCOP-01-01-03-02 : 기본정보
          -->
          <tab ref="perInfoTab" css-type="type3" :title-list="['MCOP-01-01-03-02']">
            <template #0>
              <corporationInfoTab1 ref="tab1" :data.sync="perInfo" />
            </template>
          </tab>
        </template>
        <template v-else>
          <!--
            MCOP-01-01-03-02 : 기본정보
            MCOP-01-01-03-03 : 법인주소
            MCOP-01-01-03-04 : 대표자주소
          -->
          <tab
            ref="perInfoTab"
            css-type="type3"
            :title-list="['MCOP-01-01-03-02', 'MCOP-01-01-03-03', 'MCOP-01-01-03-04']"
          >
            <template #0>
              <corporationInfoTab1 ref="tab1" :data.sync="perInfo" />
            </template>
            <template #1>
              <corporationInfoTab2 ref="tab2" :data.sync="perInfo" />
            </template>
            <template #2>
              <corporationInfoTab3 ref="tab3" :data.sync="perInfo" />
            </template>
          </tab>
        </template>
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md gray" @click="goPrevStep">{{ /*취소*/ $t("MCOM-0000002") }}</button>
      <button class="btn md normal" @click="goNextStep">{{ /*수정*/ $t("MCOP-01-01-03-14") }}</button>
    </div>
  </section>
</template>
<script>
import corporationInfoTab1 from "@/components/page/admin/CorporationInfoTab1";
import corporationInfoTab2 from "@/components/page/admin/CorporationInfoTab2";
import corporationInfoTab3 from "@/components/page/admin/CorporationInfoTab3";
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";
import { required } from "vuelidate/lib/validators";

export default {
  extends: Common,
  components: {
    corporationInfoTab1,
    corporationInfoTab2,
    corporationInfoTab3,
  },
  validations: {
    RBF0409E40_data: {
      //대표자 휴대폰번호
      cphnNo: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGIND) return true;
          if (this.siteCode === this.$config.SITECODE_OGHCM) return true;
          return required(paramObj.cphnNo);
        },
      },
      //대표자 이메일 주소
      rprsEmad1: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGHCM) return true;
          return required(paramObj.rprsEmad1);
        },
      },
      // 법인소재지주소
      coprAddr1: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGIND) return true;
          if (this.siteCode === this.$config.SITECODE_OGAUC) return true;
          return required(paramObj.coprAddr1);
        },
      },
      // 대표자주소
      rprsAddr1: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGIND) return true;
          if (this.siteCode === this.$config.SITECODE_OGAUC) return true;
          if (paramObj.postSendAreaDstcd === "3") return true;
          return required(paramObj.rprsAddr1);
        },
      },
      // 우편물 수신
      postSendAreaDstcd: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGIND) return true;
          return required(paramObj.postSendAreaDstcd);
        },
      },
      // 거래 Statement 우편발송 여부
      postSendYn: {
        required: function (val, paramObj) {
          if (this.siteCode !== this.$config.SITECODE_OGAUC) return true;
          return required(paramObj.postSendYn);
        },
      },
      // Statement 우편수신서비스 신청
      isPostSendYnAgree: {
        required: function (val, paramObj) {
          if (this.siteCode !== this.$config.SITECODE_OGAUC) return true;
          if (this.RBF0409E40_data.postSendYn !== "1") return true;

          const isPostSendYnAgree = paramObj.isPostSendYnAgree === true;
          return required(isPostSendYnAgree ? isPostSendYnAgree : undefined);
        },
      },
    },
  },
  computed: {
    ...mapFields("admin/personalInfo", ["RBF0409E40", "RBF0409E40_data"]),
  },
  data() {
    return {
      perInfo: {},
    };
  },
  created() {
    if (Object.entries(this.RBF0409E40_data).length === 0) {
      this.perInfo = _.cloneDeep(this.RBF0409E40);
    } else {
      this.perInfo = _.cloneDeep(this.RBF0409E40_data);
    }
  },
  methods: {
    goPrevStep() {
      this.$router.push({ name: "perInfoCorp" });
    },
    goNextStep() {
      this.RBF0409E40_data = this.perInfo;

      if (!_.isEmpty(this.perInfo.rprsEmailId) || !_.isEmpty(this.perInfo.rprsEmailAddress)) {
        this.RBF0409E40_data.rprsEmad1 = this.perInfo.rprsEmailId + "@" + this.perInfo.rprsEmailAddress;
      } else {
        this.RBF0409E40_data.rprsEmad1 = "";
      }

      const currentTab = this.$refs.perInfoTab.currentTab;

      if (currentTab == "0") {
        this.$refs.tab1.touch();
      } else if (currentTab == "1") {
        this.$refs.tab2.touch();
      } else if (currentTab == "2") {
        this.$refs.tab3.touch();
      }

      if (this.$v.$invalid) {
        if (
          this.$v.RBF0409E40_data.cphnNo.$invalid ||
          this.$v.RBF0409E40_data.rprsEmad1.$invalid ||
          this.$v.RBF0409E40_data.postSendAreaDstcd.$invalid ||
          this.$v.RBF0409E40_data.postSendYn.$invalid ||
          this.$v.RBF0409E40_data.isPostSendYnAgree.$invalid
        ) {
          //기본정보
          this.changeTab("1");
        } else if (this.$v.RBF0409E40_data.coprAddr1.$invalid) {
          //법인주소
          this.changeTab("2");
        } else if (this.$v.RBF0409E40_data.rprsAddr1.$invalid) {
          //대표자주소
          this.changeTab("3");
        }

        return;
      }

      this.$router.push({ name: "perInfoStep2Corp" });
    },
    async changeTab(tab) {
      /* tab: 1: 기본정보  2: 법인주소  3: 대표자주소 */
      let newTab = 0;
      const oldTab = this.$refs.perInfoTab.currentTab;

      if (tab == "1") {
        //기본정보
        newTab = 0;
      } else if (tab == "2") {
        //법인주소
        if (this.siteCode === this.$config.SITECODE_OGAUC) newTab = null;
        else if (this.siteCode === this.$config.SITECODE_OGIND) newTab = null;
        else newTab = 1;
      } else if (tab == "3") {
        //대표자주소
        if (this.siteCode === this.$config.SITECODE_OGAUC) newTab = null;
        else if (this.siteCode === this.$config.SITECODE_OGIND) newTab = null;
        else newTab = 2;
      }

      if (newTab != oldTab) {
        await this.$refs.perInfoTab.tabClick(newTab);

        if (tab == "1") this.$refs.tab1.touch();
        else if (tab == "2") this.$refs.tab2.touch();
        else if (tab == "3") this.$refs.tab3.touch();
      }
    },
  },
};
</script>
